/**
 * Update url
 *
 * @param {URL|String} url
 * @param {Boolean} saveState if true - session will saved in history
 * as new object, else replace last record
 *
 * @returns {void}
 */
 function changeUrl (url, saveState = false) {
  try {
    if (window.history.replaceState && !saveState) {
      // prevents browser from storing history
      window.history.replaceState(name, document.title, url)
    } else if (window.history.pushState && saveState) {
      window.history.pushState(name, document.title, url)
    } else {
      window.location.href = url
    }
  } catch (e) {}
}

let _url

/**
 * Managing URL parameters
 */
class URLParams {
  constructor (url) {
    _url = url
  }

  get url () {
    try {
      return new URL(_url || window.location.href)
    } catch (e) {
      return new URL('https://bimlib.pro')
    }
  }

  /**
   * Set parameter
   *
   * @param {String} name
   * @param {String|Number} value
   * @param {Boolean} saveState
   *
   * @returns {void}
   */
  set (name, value, saveState = false) {
    const url = this.url

    url.searchParams.set(name, value)
    changeUrl(url, saveState)

    return url
  }

  /**
   * Appends a specified key/value pair as a new search parameter.
   *
   * @param {String} name
   * @param {any} value
   * @returns {void}
   */
  append (name, value, saveState = false) {
    const url = this.url

    url.searchParams.append(name, value)
    changeUrl(url, saveState)

    return url
  }

  /**
   * Returns the first value associated with the given search parameter
   *
   * @param {String} name
   *
   * @returns {String}
   */
  get (name) {
    return this.url.searchParams.get(name)
  }

  /**
   * Returns all the values associated with a given search parameter
   *
   * @param {String} name
   *
   * @returns {Array<String>} An array of values
   */
  getAll (name) {
    return this.url.searchParams.getAll(name)
  }

  /**
   * Returns all values and parameters in array
   *
   * @returns {Array<Array<String, String>>} an array of arrays like Object.entries
   * with [key, value] structure
   */
  getAllParams () {
    return Array.from(this.url.searchParams.entries())
  }

  /**
   * Deletes the given search parameter
   * and all its associated values,
   * from the list of all search parameters.
   *
   * @param {String} name - The name of the parameter to be deleted.
   * @param {Boolean} saveState
   *
   * @returns {void}
   */
  delete (name, saveState = false) {
    const url = this.url

    url.searchParams.delete(name)
    changeUrl(url, saveState)

    return url
  }

  /**
   * Returns a USVString containing the whole URL
   *
   * @returns {String} URL string representation
   */
  toString () {
    return this.url.toString()
  }
}

const urlParams = new URLParams()

export {
  URLParams,
  urlParams
}
